import React from "react";
import { Link } from "react-router-dom";




export default function FeaturedProducts(){
    //Logic
    
    //Css
    //#region 
    const containerStyle={
        position:'relative',
        height:"15rem",
        display : "flex",
        justifyContent: 'space-evenly',
        textAlign: "center",
        alignItems: "center",
        zIndex:10,
        width: "100%",
        backgroundColor:'#F0EFEC'
    }
    
    const itemStyle = {
       display: 'flex',
       flexDirection: 'column',
       textAlign: "center",
       alignItems: "center",
       fontFamily: 'Montserrat',
       fontSize: '1.5rem',
       fontWeight: 'bold',
       gap: '15px'

    }
    const imageStyle = {
         width: '50px'  
    }
    //#endregion
    return (
    <>
        <div style={containerStyle}>
            <Link style={itemStyle} to='/support'>
                <img style={imageStyle}src="/resources/chat.png" alt="" />
                <span>Need Help?</span></Link>
            <Link style={itemStyle} to='about-us'>
                <img style={imageStyle} src="/resources/multiple-users-silhouette.png" alt="" />
                Know more about Us!</Link>
            <Link style={itemStyle} to='products'>
                <img style={imageStyle} src="/resources/setting.png" alt="" />
                What we offer!</Link>
        </div>
    </>
    )
}